var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"story-status-bar"},_vm._l((_vm.length),function(index){return _c('div',{staticClass:"story-status-bar__item",class:{
      'story-status-bar__item--watched': index - 1 < _vm.barIdx,
      'story-status-bar__item--active': index - 1 === _vm.barIdx,
      'story-status-bar__item--paused': _vm.isPaused,
    },style:(("--animation-duration: " + _vm.duration + "ms"))})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/base/stories/StoryStatusBar.vue?vue&type=template&id=1c2d50e4&scoped=true&
// module id = 1045
// module chunks = 0